"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is a basic Switch component. It's a thin wrapper to show / not show
 * the child component accepting a fallback
 */
const Switch = props => {
  const {
    condition,
    children,
    fallback = null
  } = props;
  if (condition) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fallback);
};

var _default = Switch;
exports.default = _default;